/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Fokus_TInputs */

const en_tut_fokus_t = /** @type {(inputs: Tut_Fokus_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared focus, status, and status objects`)
};

const id_tut_fokus_t = /** @type {(inputs: Tut_Fokus_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus bersama, status, dan objek status`)
};

/**
* | output |
* | --- |
* | "Shared focus, status, and status objects" |
*
* @param {Tut_Fokus_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_fokus_t = /** @type {((inputs?: Tut_Fokus_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Fokus_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_fokus_t(inputs)
	return en_tut_fokus_t(inputs)
});